import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {PriceChangeItem} from './dashboardTableTypes'
import {
  formatDashboardCurrency,
  renderDashboardDateTwoLine,
  renderDashboardLinkIcon,
  renderDashboardSku,
} from './dashboardFormatters'

const columns: DashboardColumn<PriceChangeItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Old Value', sortKey: 'old_value', render: (item) => formatDashboardCurrency(item.old_value)},
  {header: 'New Value', sortKey: 'new_value', render: (item) => formatDashboardCurrency(item.new_value)},
  {header: 'Changed At', sortKey: 'changed_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.changed_at)},
  {header: 'Url', width: 120, render: (item) => renderDashboardLinkIcon(item.broken_link)},
  // {header: 'Broken Link', render: (item) => renderDashboardLink(item.broken_link)},
]

function PriceChangesShow() {
  return <DashboardApiTableShow<PriceChangeItem> endpoint='PriceChanges' title='Price Changes' columns={columns} />
}

export default PriceChangesShow
